<template>
  <b-button
    type="button"
    variant="outline-primary"
    :disabled="disabled"
    :title="label"
    :aria-label="label"
    @click="$emit('click')"
  >
    <feather-icon
      icon="HelpCircleIcon"
      class="mr-sm-25"
    />
    <span class="d-none d-sm-inline text-nowrap">{{ label }}</span>
  </b-button>
</template>

<script>
import { BButton } from 'bootstrap-vue'

export default {
  name: 'TutorialButton',
  components: {
    BButton,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
